import type { PublicKeyCredentialCreationOptionsJSON } from '@simplewebauthn/typescript-types';

import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';
import configRequest from '@api/requests/configRequest';

export type GetCredsWebAuthnMethodData = void;

export interface GetCredsWebAuthnMethodResponse {
	public_key: PublicKeyCredentialCreationOptionsJSON;
}

const getCredsWebAuthnMethod = configRequest<GetCredsWebAuthnMethodResponse, GetCredsWebAuthnMethodData>({
	requestPrefix: 'mfa/getCredsWebAuthnMethod',
	reqConfigCreator: () => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.MFA.WEBAUTHN.GET_CREDS(),
		method: HTTP_METHODS_ENUM.POST,
	}),
});

export default getCredsWebAuthnMethod;
